import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieInterceptor } from './interceptors/cookie.interceptor';
import { ModalComponent } from './components/modal/modal.component';
import { DangerousgoodSelectionComponent } from './components/dangerousgood-selection/dangerousgood-selection.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ArticleSelectionComponent } from './components/article-selection/article-selection.component';
import { LicenseDependentButtonComponent } from './components/license-dependent-button/license-dependent-button.component';
import { PaymentSummaryComponent } from './components/payment-summary/payment-summary.component';
import { LanguageService } from './services/language.service';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { StringReplacePipe } from './pipes/string-replace.pipe';
import { RouteLanguageResolver } from './resolvers/route-language.resolver';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { TransportModeCardsComponent } from './components/transport-mode-cards/transport-mode-cards.component';
import { NotificationService } from './services/notification.service';
import { EnumKeyPipe } from './pipes/enum-key.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { QrCodeComponent } from './components/qr-code/qr-code.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DndDirective } from './components/file-upload/dnd.directive';
import { LicenseService } from './services/license.service';
import { InlineEditLabelComponent } from './components/inline-edit-label/inline-edit-label.component';
import { FileListComponent } from './components/file-list/file-list.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { DatePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';
import { ResultSelectionComponent } from './components/result-selection/result-selection.component';
import { ResultOptionsComponent } from './components/result-options/result-options.component';
import { ContactBoxComponent } from './components/contact-box/contact-box.component';
// import { TableComponent } from './components/table/table.component';
import { registerLicense } from '@syncfusion/ej2-base';
import { TableComponent } from './components/table/table.component';
import { EnumKeyValuePipe } from './pipes/enum-key-value.pipe';
import { FromUtcStringPipe } from './pipes/from-utc-string.pipe';
import { ArticleSelectionButtonComponent } from './components/article-selection-button/article-selection-button.component';

// Registering Syncfusion license key
registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1NGaF5cXmdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWXhec3RXQ2RdVkR1W0I='
);

@NgModule({
  declarations: [
    ModalComponent,
    DangerousgoodSelectionComponent,
    ArticleSelectionComponent,
    LicenseDependentButtonComponent,
    PaymentSummaryComponent,
    SafeHtmlPipe,
    StringReplacePipe,
    LoadingSpinnerComponent,
    MultiselectComponent,
    StepperComponent,
    TransportModeCardsComponent,
    EnumKeyPipe,
    EnumKeyValuePipe,
    SafeUrlPipe,
    QrCodeComponent,
    FileUploadComponent,
    DndDirective,
    InlineEditLabelComponent,
    FileListComponent,
    AccordionComponent,
    ResultSelectionComponent,
    TableComponent,
    ResultOptionsComponent,
    ContactBoxComponent,
    FromUtcStringPipe,
    ArticleSelectionButtonComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    DatePickerModule,
    TimePickerModule,
    AutoCompleteModule
  ],
  exports: [
    ModalComponent,
    DangerousgoodSelectionComponent,
    ArticleSelectionComponent,
    LicenseDependentButtonComponent,
    PaymentSummaryComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    StringReplacePipe,
    LoadingSpinnerComponent,
    MultiselectComponent,
    StepperComponent,
    TransportModeCardsComponent,
    EnumKeyPipe,
    EnumKeyValuePipe,
    FromUtcStringPipe,
    QrCodeComponent,
    FileListComponent,
    AccordionComponent,
    DatePickerModule,
    TimePickerModule,
    AutoCompleteModule,
    FileListComponent,
    FileUploadComponent,
    ResultSelectionComponent,
    ResultOptionsComponent,
    TableComponent,
    ContactBoxComponent,
    ArticleSelectionButtonComponent
  ],
  providers: [
    CookieInterceptor,
    LoadingInterceptor,
    LanguageService,
    LicenseService,
    NotificationService,
    RouteLanguageResolver,
    EnumKeyPipe,
    EnumKeyValuePipe,
  ],
})
export class UiModule { }
